import { render, staticRenderFns } from "./StitchLoader.vue?vue&type=template&id=0fb8c9b2&scoped=true&"
import script from "./StitchLoader.vue?vue&type=script&lang=js&"
export * from "./StitchLoader.vue?vue&type=script&lang=js&"
import style0 from "./StitchLoader.vue?vue&type=style&index=0&id=0fb8c9b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb8c9b2",
  null
  
)

export default component.exports